import { render, staticRenderFns } from "./tlQaInfo.vue?vue&type=template&id=011c1822&scoped=true&"
import script from "./tlQaInfo.vue?vue&type=script&lang=js&"
export * from "./tlQaInfo.vue?vue&type=script&lang=js&"
import style0 from "./tlQaInfo.vue?vue&type=style&index=0&id=011c1822&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c1822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011c1822')) {
      api.createRecord('011c1822', component.options)
    } else {
      api.reload('011c1822', component.options)
    }
    module.hot.accept("./tlQaInfo.vue?vue&type=template&id=011c1822&scoped=true&", function () {
      api.rerender('011c1822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/quality/tlQaInfo.vue"
export default component.exports